import { Box, Button } from '@mantine/core';
import logoUrl from '../../../../assets/icons/tripleNet.svg'
import { useStyles } from './style';
import { Link } from 'react-router-dom';


const LandingPageHeader = () => {
    const { classes, theme } = useStyles(useStyles);
    const currentPath = window.location.pathname
    const customStyle = {
        display: currentPath === '/' ? 'flex' : 'none'
    }
    return (
        <Box style={customStyle} className={classes.wrapper}>
                <img className={classes.logo} src={logoUrl} alt='logo' />
                <Link to='/login' >
                    <Button radius="xl"
                        ta="right"
                        size="lg"
                        variant="filled" className={classes.btn}>Login
                    </Button>
                </Link>

        </Box>
    );
}




export default LandingPageHeader;